/* eslint-disable space-before-function-paren */
/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:49:24
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2019-12-18 14:30:11
 */

const state = {
  userInfo: {}
}

const actions = {
  set_userInfo(context, option) {
    context.commit('set_userInfo', option)
  }
}

const getters = {
  niceName: state => {
    return state.userInfo.niceName
  },
  cover: state => {
    return state.userInfo.cover
  }
}

const mutations = {
  set_userInfo(state, option) {
    state.userInfo = option
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js